import { imageUrl } from "./api";

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
}

function drawText(ctx, text, color, x, y, w, h) {
  const fontSize = Math.max(8, h * 0.42);
  ctx.fillStyle = color || "#000000";
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.font = `700 ${fontSize}px Georgia, 'Times New Roman', serif`;
  const words = String(text || "").split(/\s+/);
  const lines = [];
  let line = "";
  for (const wd of words) {
    const test = line ? `${line} ${wd}` : wd;
    if (ctx.measureText(test).width > w && line) {
      lines.push(line);
      line = wd;
    } else {
      line = test;
    }
  }
  if (line) lines.push(line);
  const lineH = fontSize * 1.05;
  let cy = y + h / 2 - (lines.length * lineH) / 2 + lineH / 2;
  for (const ln of lines) {
    ctx.fillText(ln, x + w / 2, cy);
    cy += lineH;
  }
}

// Composite the design layers into a single transparent PNG data URL (print-ready).
export async function renderDesignPNG(layers, size = 1400) {
  if (!layers || layers.length === 0) return null;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  for (const layer of layers) {
    const bx = layer.box || { x: 0, y: 0, w: 100, h: 100 };
    const x = (bx.x / 100) * size;
    const y = (bx.y / 100) * size;
    const w = (bx.w / 100) * size;
    const h = (bx.h / 100) * size;
    if (layer.type === "text") {
      drawText(ctx, layer.text, layer.color, x, y, w, h);
    } else if (layer.src) {
      try {
        const img = await loadImage(layer.src.startsWith("data:") ? layer.src : imageUrl(layer.src));
        if (!img.naturalWidth || !img.naturalHeight) {
          ctx.drawImage(img, x, y, w, h);
        } else {
          const r = Math.min(w / img.naturalWidth, h / img.naturalHeight);
          const dw = img.naturalWidth * r;
          const dh = img.naturalHeight * r;
          ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
        }
      } catch {
        // skip layers that fail to load
      }
    }
  }
  try {
    return canvas.toDataURL("image/png");
  } catch {
    return null;
  }
}

export function downloadDataUrl(dataUrl, filename) {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

// Convenience: render + download in one call.
export async function downloadDesign(layers, filename = "papag-design.png") {
  const url = await renderDesignPNG(layers);
  if (url) downloadDataUrl(url, filename);
  return url;
}
